import type { GetDraftPricingCalculationPayload } from '@fourthwall/services/dist/CustomizationApiClient'
import { CustomizationApiClient } from '@fourthwall/services/dist/CustomizationApiClient'
import type { GetDraftPricingCalculationResponse } from '@fourthwall/services/dist/CustomizationApiClient/models'
import type { DraftId } from '@fourthwall/services/dist/models/customization'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

export const useDraftPricingCalculationQuery = (
  customizationId?: DraftId,
  params?: GetDraftPricingCalculationPayload,
  options?: UseQueryOptions<GetDraftPricingCalculationResponse | undefined>,
) => {
  const draftPricingCalculationQuery = useQuery<GetDraftPricingCalculationResponse | undefined>({
    queryKey: ['useDraftPricingCalculationQuery', customizationId, params],
    queryFn: async () => {
      if (customizationId) {
        const { data } = await CustomizationApiClient.getDraftPricingCalculation(
          customizationId,
          params,
        )

        return data
      }
    },
    ...options,
  })

  return {
    draftPricingCalculation: draftPricingCalculationQuery.data,
    draftPricingCalculationQuery,
  }
}
